import { Vue } from 'vue'
import { API } from './core'

export class Category {
  create () {
    return API.instance().put('/transaction-category/', this).then((resp) => {
      const item = Category.createFromJson(resp.data.data.data)
      Category.Cached[item.key] = item
      return item
    })
  }
  save () {
    return API.instance().post(`/transaction-category/${this.key}/`, this).then((resp) => {
      const item = Category.createFromJson(resp.data.data.data)
      Category.Cached[item.key] = item
      return item
    })
  }

  updateFromServer (state) {
    return API.instance().get(`/category/${this.key}`).then((resp) => {
      const updatedCategory = resp.data.data.data

      Object.entries(updatedCategory).forEach(obj => Vue.set(this, obj[0], obj[1]))
      if (state) {
        state.changeToLoaded()
      }
      Category.Cached[updatedCategory.key] = this
    })
  }

  static sortedItems (items) {
    return items.sort((x, y) => {
      if (x.name > y.name) {
        return 1
      }
      return -1
    })
  }

  static newEmpty () {
    let category = new Category()
    category.name = ''
    category.is_credit = false
    category.show_in_report = true
    category.notes = null
    category.parent = null
    return category
  }
  static createFromJson (raw) {
    let category = Category.newEmpty()
    category = Object.assign(category, raw)
    return category
  }
  static list (useFresh) {
    if (!useFresh) {
      const values = Category.sortedItems(Object.values(Category.Cached))
      if (values.length > 1) {
        return Promise.resolve(values)
      }
    }

    return API.instance().get('/transaction-category/').then((resp) => {
      let data = resp.data.data.data.map((raw) => Category.createFromJson(raw))
      data = Category.sortedItems(data)
      data.forEach((item) => {
        Category.Cached[item.key] = item
      })
      return data
    })
  }

  static fetch (categoryKey) {
    return this.fromKey(categoryKey).updateFromServer()
  }

  static fromKey (categoryKey) {
    const category = Category.newEmpty()
    category.key = categoryKey
    category.name = `-`
    return category
  }

  static useCachedOrFetch (categoryKey) {
    if (Category.Cached[categoryKey]) {
      return Category.Cached[categoryKey]
    }
    const category = this.fromKey(categoryKey)
    if (categoryKey) {
      Category.Cached[categoryKey] = category
      if (categoryKey && categoryKey !== '0') {
        category.updateFromServer()
      }
    }
    return category
  }
}

Category.Cached = {}

export class CategoryKey {
  constructor (key) {
    this.key = key
    if (key && key.key) {
      this.key = key.key
    }
    this.loadedCategory = null
  }
  get category () {
    if (this.loadedCategory === null) {
      this.loadedCategory = Category.useCachedOrFetch(this.key)
    }
    return this.loadedCategory
  }

  getCategory () {
    return this.category
  }

  toString () {
    return this.key
  }
}
